import { Divider } from '@zenterprise-inc/ui';
import { useRouter } from 'next/router';

import DecisionNPKISection from '@/components/tax-refund/individual/DecisionRefund/SelectAuth/DecisionNPKISection';
import DecisionSimpleAuthSection from '@/components/tax-refund/individual/DecisionRefund/SelectAuth/DecisionSimpleAuthSection';
import { COMMON_PATHS, DECISION_PATHS } from '@/lib/constants/paths';

const DecisionSelectAuthContent = () => {
  const router = useRouter();

  const handleSimpleAuthStep = () => {
    router.push({
      pathname: COMMON_PATHS.간편인증_정보입력,
      query: Object.assign({}, router.query, { from: 'decision' })
    });
  };

  const handleNPKIStep = () => {
    router.push({
      pathname: `${DECISION_PATHS.공동인증서설치판단}`,
      query: router.query
    });
  };

  return (
    <>
      <DecisionSimpleAuthSection handleSimpleAuthStep={handleSimpleAuthStep} />
      <div className="mt-6" />
      <Divider.Section />
      <div className="mt-4" />
      <DecisionNPKISection handleNPKIStep={handleNPKIStep} />
    </>
  );
};

export default DecisionSelectAuthContent;
